import { Config } from '@bonanza-social/toolkit/config';

declare global {
  interface Window {
    fbq?: FbqFunction;
    _fbq?: FbqFunction;
  }
}

type FbqArg =
  | string
  | number
  | boolean
  | null
  | undefined
  | Record<string, unknown>;

type FbqQueueItem = [string, ...FbqArg[]];

interface FbqFunction {
  (...args: FbqQueueItem): void;
  callMethod?: (...args: FbqQueueItem) => void;
  queue: FbqQueueItem[];
  push: FbqFunction;
  loaded: boolean;
  version: string;
}

export const initMetaPixel = (): void => {
  const pixelId = Config.META_PIXEL_ID;

  if (typeof window === 'undefined') return;
  if (!pixelId) return;
  if (window.fbq) return;

  const fbq = ((...args: FbqQueueItem) => {
    if (fbq.callMethod) {
      fbq.callMethod(...args);
    } else {
      fbq.queue.push(args);
    }
  }) as FbqFunction;

  fbq.queue = [];
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.push = fbq;

  window.fbq = fbq;
  window._fbq = fbq;

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';

  script.onload = () => {
    window.fbq?.('init', pixelId);
    window.fbq?.('track', 'PageView');
  };

  const firstScript = document.getElementsByTagName('script')[0];
  firstScript?.parentNode?.insertBefore(script, firstScript);
};

export const trackPageView = (): void => {
  if (typeof window === 'undefined') return;
  window.fbq?.('track', 'PageView');
};

export const trackMetaEvent = (
  eventName: string,
  params?: Record<string, unknown>,
): void => {
  if (typeof window === 'undefined') return;

  if (params) {
    window.fbq?.('track', eventName, params);
    return;
  }

  window.fbq?.('track', eventName);
};
